import { Typography } from '@design-system';
import './WorksiteStatus.scss';

export type WorksiteStatusProps = {
    status: 'progress' | 'done';
};

export const WorksiteStatus: React.FC<WorksiteStatusProps> = ({ status }) => {
    return (
        <div className={`worksite-status ${status}`}>
            <div className="worksite-status-ellipse"></div>
            <Typography intrinsic="h5" color={status === 'progress' ? 'yellow' : 'green'}>
                {status === 'progress' ? 'En cours' : 'Terminé'}
            </Typography>
        </div>
    );
};
